<template lang="pug">
.lk-payment-detail(v-if="data")
	.lk-payment-detail__container
		component.lk-payment-detail__title.h1(v-if="data.title" :is="data.titleLevel || 'h1'" v-html="data?.title")
		.lk-payment-detail__subtitle(v-if="data.subtitle") {{ data.subtitle }}
		.lk-payment-detail__inner
			v-loader(:loading="loading")
			.lk-payment-detail__content
				.lk-payment-detail__items
					template(
						v-for="({id, prefixId = 'ID', name, type, img, date, price, term, fullPrice},index) in data?.items"
						:key="index" )
						.lk-payment-detail__row
							v-ads(:data-source="{id, prefixId, name, type, img, date, term, price, fullPrice}")
				.payment-form(v-if="data.groups")
					.payment-form__group(v-for="(group, index) in data.groups" :style="{width: group.width || null}" :key="group.id || index")
						.payment-form__title(v-if="group.title") {{group.title}}
						transition(name="fade")
							transition-group.profile-form__fields(tag="div" name="content-fade")
								template(v-for="(field, index) in data.fields" :key="index" )
									template(v-if="field.groupId === group.id")
										.payment-form__row
											.payment-form__label(v-if="field.label") {{field.label}}
											.payment-form__row-field(:class="{'payment-form__row-field--center' : field.hidden}")
												template(v-if="field.hidden")
													.fake-field
														.fake-field__text-old(v-if="field.valueOld") {{field.valueOld}}
														.fake-field__text(v-if="field.value" :class="field.className") {{field.value}}
												template(v-else)
													v-field(
														:field="{...field, mode: 'no-label'}"
														v-model="field.value"
														@update:model-value="handleInput(field)"

														@removePromocode="handleRemovePromocode"
														@addPromocode="handleAddPromocode"
													)
				//.lk-payment-detail__action(v-if="data.link && data.link.href")
				//	a.btn.btn--primary(:href="data.link.href") {{data.link.text}}
				.lk-payment-detail__action(v-if="data.link")
					button.btn.btn--primary(@click="onSubmit") {{data.link.text}}
					a.hidden(ref="hidden-link" :href="link" )
</template>

<script>
	import sourceMixin from '../components/mixins/v-mixin-source.vue';
	import isMobMixin from '../components/mixins/v-mixin-is-mob.vue'

	export default {
		mixins: [
			sourceMixin,
			isMobMixin
		],

		data() {
			return {
				data: null,
				timerId: null,
				link: null,
				loading: false,
			}
		},

		methods: {

			dataSet(data) {
				this.data = data;

				if (data.redirect) {
					this.link = `https://${window.location.hostname}${data.redirect}`
					this.$nextTick(() => {
						this.$refs['hidden-link'].click()
						this.loading = true
					})
				}

			},
			handleRemovePromocode(e) {
				const {action, value} = e;
				this.requestDataLoad(action, value);
			},

			handleAddPromocode(e) {
				const {action, value} = e;
				this.requestDataLoad(action, value);
			},

			handleInput(field) {
				if(field.autosubmit) {
					this.requestDataLoad();
				}
			},

			onSubmit() {
				this.requestDataLoad('submit')
			},

			requestDataLoad(action = null, value = null) {
				clearTimeout(this.timerId);

				let data = this.data.fields.reduce((acc, cur) => {

					if(cur.value) {
						return {
							...acc,
							[cur.id]: cur.value
						}
					}
				}, {})

				this.timerId = setTimeout(() => {
					this.dataLoad({
						url: this.data.remote,
						delay: true,
						data: {
							...data,
							action,
							value,
						}
					});
				}, 300)

			},
		}

	}
</script>
